// angular
//     .module("HeroPRO")
//     .controller("MainController", MainController);

import _ from 'lodash';
import * as psl from 'psl';

function clearTempAuthCookie() {
    const domain = `.${psl.parse(window.location.hostname)}`;
    document.cookie = `copo_token=;domain=${domain};expires=${new Date(0).toUTCString()}`;
}

function getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let cookie of cookieArray) {
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }

    return '';
}

/* @ngInject */
export default function MainController(
    $q, $http, $scope, $window, $location, $state, $rootScope, $analytics, $uibModal, HPConfig, UserData, Timestamp, raSpinnerService, coachmark, HPRoles, ModalService,
    UserAuthFactory, AuthenticationFactory, FundingRequestDatastore, UiDisplayFactory, PartnerAppsFactory, TopNavFactory, BenjiUserFactory, PermissionsFactory, document, $transitions, HISWizardFactory,
) {
    const vm = this;

    // Check the URL for a token
    const token = getCookie('copo_token');
    if (token) {
        clearTempAuthCookie();
        AuthenticationFactory.setAuthenticationData({ access_token: token });
    }

    // Health check used to show a blank page while checking authentication
    vm.isAuthorized = false;
    $http.get(`${HPConfig.heroProApi}HealthChecks/AuthorizedPing`).then(() => {
        vm.isAuthorized = true;
    });

    vm.hisTrainingMandate = {};
    vm.forceHIStraining = false;

    vm.HPConfig = HPConfig;
    vm.locationId = 0;

    vm.showSidebar = true;
    vm.isBenjiOnlyUser = false;
    vm.shouldBenjiRedirect = false;
    vm.currentYear = new Date().getFullYear();

    UiDisplayFactory.setDisplayRule('isBenjiUser', false);
    UiDisplayFactory.setDisplayRule('isBenjiOnlyUser', false);

    vm.showSpinner = true;

    if ($window.sessionStorage.getItem('showSpecialNotice') === null) {
        $window.sessionStorage.setItem('showSpecialNotice', true);
    }

    const targetDate = new Date('2019-01-01');
    function targetDateHasPassed() {
        return new Date() >= targetDate;
    }

    const showSpecialNoticeModal = function showSpecialNoticeModal() {
        const today = new Date();
        const limitDate = new Date(2019, 0, 1);

        // UserData.getUserLocations().then((userLocations) => {
        //     const isCaliforniaUser = _.some(userLocations, location => location.State === 'CA');
        //     if (isCaliforniaUser === true) {
        //         if ($window.sessionStorage.getItem('showSpecialNotice') !== null && $window.sessionStorage.getItem('showSpecialNotice') === 'true') {

        //          if(targetDateHasPassed())
        //          return;
        //             ModalService.launchLgModal({
        //                 templateUrl: 'app/common/specialNotice/specialNotice.html',
        //                 windowClass: 'kbyg-modal specialNotice-modal',
        //                 controller: 'MainController',
        //                 controllerAs: 'main',
        //             });
        //             $window.sessionStorage.setItem('showSpecialNotice', false);
        //         }
        //     }
        // });
    };

    const closeSpecialNoticeModal = function closeSpecialNoticeModal(buttonClicked) {
        if (buttonClicked) {
            $analytics.eventTrack('AB1284 Click', { category: 'Special Notice' });
        } else {
            $analytics.eventTrack('AB1284 Exit', { category: 'Special Notice' });
        }
        ModalService.closeLgModal();
    };
    vm.closeSpecialNotice = closeSpecialNoticeModal;

    $scope.$on('ShowMainSpinner', () => {
        vm.showSpinner = true;
    });

    $scope.$on('HideMainSpinner', () => {
        vm.showSpinner = false;
        // leaving this commented out for future reference of where
        // to pop the special notice
        showSpecialNoticeModal();
    });

    vm.startCoachmarkTour = () => {
        coachmark.startCoachmarkTour(false);
    };

    $scope.$on('HPErrorUnauthorized', () => {
        // If the current URL contains httpError, don't set that as the returnURL on the login page. Set it to /dashboard instead.
        let returnURL = $window.location.href;
        const indexOfHttpError = returnURL.toLowerCase().indexOf('httperror');
        if (indexOfHttpError !== -1) {
            returnURL = `${returnURL.substring(0, indexOfHttpError)}dashboard`;
        }
        if (vm.isAuthorized) {
            $window.location.href = `${HPConfig.heroProLoginLink}?SessionTimeout=true&ReturnUrl=${encodeURIComponent(returnURL)}`;
        } else {
            $window.location.href = `${HPConfig.heroProLoginLink}?&ReturnUrl=${encodeURIComponent(returnURL)}`;
        }
    });

    $scope.$on('HPErrorForbidden', () => {
        $window.location.href = HPConfig.heroProLink;
    });

    $scope.$on('HPErrorNotFound', (event, data) => {
        $location.path(`/httpError/${data.status}`);
    });

    $scope.$on('HPErrorServer', (event, data) => {
        vm.showSpinner = false;
        $location.path(`/httpError/${data.status}/${data.headerRACtx.ti}`);
    });

    $scope.$on('HPErrorUnknown', (event, data) => {
        if (data.headerRACtx.ti !== null) {
            $location.path(`/httpError/${data.status}/${data.headerRACtx.ti}`);
        } else {
            $location.path(`/httpError/${data.status}`);
        }
    });

    $scope.$on('officesUpdated', loadLocations);

    $scope.$on('RefreshPermissions', () => {
        PermissionsFactory.getPermissions({ fetchNewData: true });
    });

    function updateLocation(event, userLocation) {
        const oldLocation = vm.currentLocation;
        vm.currentLocation = userLocation;
        UserData.setCurrentLocation(userLocation);
        UiDisplayFactory.setDisplayData(vm.currentLocation);

        $rootScope.$broadcast('HPLocationChange', userLocation, () => {
            vm.currentLocation = oldLocation;
            UserData.setCurrentLocation(oldLocation);
        });

        $analytics.eventTrack('Location Change', { category: 'TopNav', label: `${$location.url()}:${userLocation.LocationNickname}` });
    }
    vm.updateLocation = updateLocation;

    function onStateChangeStart(transitionEvent) {
        const toState = transitionEvent.$to();
        const fromState = transitionEvent.$from();

        // Don't process this function if the fromState and toState is an error page.
        // This prevents an infinite loop of errors from occuring.
        if (fromState.name.indexOf('httpError') === -1 && toState.name.indexOf('httpError') === -1) {
            UserAuthFactory.getAuthorization().then((result) => {
                // AdvancedRegistrationStatus -- 0 = None -- 2 = Completed
                if (result.AdvancedRegistrationStatus !== '0' && result.AdvancedRegistrationStatus !== '2') {
                    // Process advanced reg in HEROPro
                    $rootScope.$broadcast('loadNotifications');
                } else if (vm.forceHISTraining) {
                    vm.showSpinner = false;
                    HISWizardFactory.openHISWizardModal(true);
                } else {
                    // Advanced reg status is good, but Terms and Conditions need to be signed.
                    UserData.getCurrentLocation().then((currentLocation) => {
                        UserAuthFactory.getRegistrationInfo(currentLocation.LicenseNumber).then((response) => {
                            if (response.data.ShouldSignTC) {
                                vm.showSpinner = false;
                                $uibModal.open({
                                    templateUrl: 'app/common/specialNotice/shouldSignTC.html',
                                    keyboard: false,
                                    size: 'full-screen',
                                    controller: 'MainController',
                                    controllerAs: 'main',
                                    animation: false,
                                });
                            } else {
                                $rootScope.$broadcast('loadNotifications');
                            }
                        });
                    });
                }
            });
        }
    }

    $transitions.onStart({}, onStateChangeStart);

    function trackPageEvent(toState, toParams) {
        let myurl = toState.self.url;

        for (const param in toParams) {
            if (param) {
                myurl = myurl.replace(`:${param}`, toParams[param]);
            }
        }

        UserData.getCurrentLocation().then((data) => {
            $analytics.setUserProperties({ dimension1: data.ContractorNumber }); // RACNumber
            $analytics.setUserProperties({ dimension2: data.OrganizationId }); // organizationID
            $analytics.pageTrack(myurl);
        });
    }

    function onStateChangeSuccess(transitionEvent) {
        const toState = transitionEvent.$to();

        // Capture the state change time and store it in the timestamp factory
        Timestamp.setTimestamp('stateChangeTimestamp');

        // Log the page event to Google Analytics
        trackPageEvent(toState, toState.params);

        // Unregister all existing spinners
        raSpinnerService.unregisterAll();

        // Clear Loaded Record
        FundingRequestDatastore.clearPrimaryInformation();

        // Find the existing coachmark tour and end it
        if (coachmark.getCurrTour() !== undefined && coachmark.getCurrTour() !== null) {
            coachmark.endCoachmarkTour();
        }
    }
    $transitions.onSuccess({}, onStateChangeSuccess);

    function isPageActive(viewLocation) {
        return viewLocation === $state.current.name;
    }
    vm.isPageActive = isPageActive;

    function checkForBenji() {
        if (!vm.userData || !vm.userLocations) {
            return;
        }

        // Add RA Employee condition
        if (!_.contains(vm.userData.Roles, HPRoles.COPO_COMPANY_ADMIN.Name) &&
            !_.contains(vm.userData.Roles, HPRoles.COPO_COMPANY_MGR.Name) &&
            !_.contains(vm.userData.Roles, HPRoles.COPO_ADMIN.Name) &&
            !_.contains(vm.userData.Roles, HPRoles.COPO_MGR.Name) &&
            !_.contains(vm.userData.Roles, HPRoles.COPO_REP.Name) &&
            !_.contains(vm.userData.Roles, HPRoles.COPO_PROJECT_REP.Name) &&
            !_.contains(vm.userData.Roles, HPRoles.COPO_RAEMPLOYEE.Name)) {
            return;
        }

        // Check if the user is selling Benji in any of their locations
        const isBenjiUser = _.some(vm.userLocations, location => location.FinancingProducts !== undefined && location.FinancingProducts !== null && location.FinancingProducts.indexOf('BENJI') !== -1);

        if (isBenjiUser === true) {
            UiDisplayFactory.setDisplayRule('isBenjiUser', true);
        }

        // Check if the user is only selling Benji in all of their locations
        vm.isBenjiOnlyUser = true; //6/24/21 - HERO Pro should think everyone is always just Benji, even when they have an LP record in addition to Benji at this point.  This was broke in Prod on Deployment night.  //_.every(vm.userLocations, location => location.FinancingProducts !== undefined && location.FinancingProducts !== null && location.FinancingProducts.length === 1 && location.FinancingProducts.indexOf('BENJI') !== -1);

        if (vm.isBenjiOnlyUser === true) {
            UiDisplayFactory.setDisplayRule('isBenjiOnlyUser', true);

            vm.showSidebar = false;

            BenjiUserFactory
                .setIsBenjiUserOnly(vm.isBenjiOnlyUser)
                .doNotRedirectOnAccountPages();
        }
    }

    function loadLocations() {
        return UserData.getUserLocations().then((response) => {
            vm.userLocations = response;
        });
    }

    UserData.getUserData().then((response) => {
        vm.userData = response;
        if (vm.userData && vm.userData.ContractorUserId) {
            $analytics.setUserProperties({ dimension3: vm.userData.ContractorUserId }); // contractorUserID
            $analytics.setUsername(vm.userData.ContractorUserId); // contractorUserID
        }

        UiDisplayFactory.setDisplayRule('suspendedCompliance', vm.userData.IsSuspendedCompliance);

        loadLocations().then(() => {
            checkForBenji();

            // Check if we need to force HIS training modal
            UserData.getHISTrainingMandate().then((response) => {
                vm.hisTrainingMandate = response;
                if (vm.hisTrainingMandate.IsTrainingRequired || vm.hisTrainingMandate.IsLicenseEntryRequired) {
                    const today = new Date();
                    const gpExpire = Date.parse(vm.hisTrainingMandate.TrainingRequiredBy);
                    if (gpExpire - today < 0) {
                        vm.forceHISTraining = true;
                        HISWizardFactory.openHISWizardModal(true);
                    }
                } else if (vm.hisTrainingMandate.IsLicenseSuspended || vm.hisTrainingMandate.IsLicenseExpired) {
                    vm.forceHISTraining = true;
                    HISWizardFactory.openHISWizardModal(true);
                }
            });

            UserData.getCurrentLocation().then((currentLocation) => {
                vm.currentLocation = currentLocation;

                UiDisplayFactory.setDisplayData(vm.currentLocation);

                if (PermissionsFactory.hasPermission('Coqr.LinkEnabled')) {
                    UiDisplayFactory.setDisplayRule('showCoQR', true);
                }
            });
        });
    });

    vm.benjiLinkClick = (newWindow) => {
        if (newWindow === true) {
            $window.open(PartnerAppsFactory.getBenjiLink(), '_blank');
        } else {
            $window.location.href = PartnerAppsFactory.getBenjiLink();
        }
    };

    vm.applicationClick = function () {
        let contractorId = vm.currentLocation.ContractorId;
        // More than one location and "All Locations" is selected, then get the first location in the list (i.e. the main location)
        if (contractorId === '' && vm.userLocations.length > 1) {
            contractorId = vm.userLocations[1].ContractorId;
        }
        const newWindow = $window.open('');
        PartnerAppsFactory.getOneAppLink(contractorId).then((result) => {
            newWindow.location = `${result}&BLS=HEROPortal`;
        });
    };
}



// WEBPACK FOOTER //
// ./src/app/MainController.js